/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter/types';
import { delayedResponse, makeMockResponse } from '../mockUtils';
import { delayedDownloadingListItemFactory } from './downloadingsFactories';
import { DelayedDownloadingsListItemDto } from './downloadingsClient.typings';

const DELAYED_DOWNLOADS: RegExp = /\/downloads$/;
const GET_URL_FOR_DOWNLOADING: RegExp = /\/downloads\/url/;

export function addDownloadingsMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onGet(DELAYED_DOWNLOADS).reply((config) => {
        const data: DelayedDownloadingsListItemDto[] = delayedDownloadingListItemFactory.list({ count: 15 });

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });

    mockAdapter.onDelete(DELAYED_DOWNLOADS).reply((config) => {
        return delayedResponse(makeMockResponse(200, 'OK', config), Math.random() * 1000);
    });

    mockAdapter.onGet(GET_URL_FOR_DOWNLOADING).reply((config) => {
        const data = `http://someUrl/${config.params.name}`;

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });
}
